import styled from 'styled-components'
import React, {useEffect, useState} from 'react'
import TextField from '@material-ui/core/TextField'
import {handleAutocomplete, onChangeStringHandler} from 'lib/dom'
import {Autocomplete} from '@material-ui/lab'
import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {ajax, useObserve} from 'lib/rx'
import {debounceTime, filter, map, switchMap, tap} from 'rxjs/operators'
import {useAuthToken} from 'obvio/auth'
import {Attendee} from 'Event/attendee'
import {Service} from 'organization/Event/Services/ServicesProvider'

const MIN_SEARCH_CHARS = 3

export default function TestAttendeeSearchField(props: {
  value: Attendee | null
  onChange: (attendee: Attendee | null) => void
  integration?: Service
  disabled?: boolean
}) {
  const {value, onChange, integration, disabled} = props
  const [name, setName] = useState('')
  const {value$, onReady} = useObserve(name)
  const [options, setOptions] = React.useState<Attendee[]>([])
  const [loading, setLoading] = React.useState(false)

  const {
    event: {slug},
  } = useEvent()
  const token = useAuthToken()

  useEffect(() => {
    if (!onReady) {
      return
    }

    value$
      .pipe(
        filter((value) => {
          return value.length >= MIN_SEARCH_CHARS
        }),
        tap(() => {
          setLoading(true)
        }),
        debounceTime(500),
        switchMap((name) => {
          const url = api(
            `/events/${slug}/attendees/?search=${name}&integration=${
              integration ?? ''
            }`,
          )

          return ajax.get(url, {
            accessToken: token,
          })
        }),
        map((res) => res.response),
        tap(() => {
          setLoading(false)
        }),
      )
      .subscribe({
        next: (options) => {
          setOptions(options.data)
        },
      })

    onReady()
  }, [value$, token, slug, onReady, integration])

  return (
    <Box>
      <Autocomplete
        disablePortal
        disabled={disabled}
        options={options}
        value={value || null}
        onChange={handleAutocomplete(onChange)}
        getOptionLabel={(option) =>
          `${option.first_name} ${option.last_name} - ${option.email}`
        }
        loading={loading}
        closeIcon=""
        aria-label="tag id holder"
        noOptionsText={'Type to search. Minimum length: 3 characters.'}
        getOptionSelected={(option, value) => option.id === value.id}
        renderInput={(params) => {
          return (
            <>
              <TextField
                {...params}
                onChange={onChangeStringHandler(setName)}
                variant={'standard'}
                disabled={disabled}
                fullWidth
                helperText={''}
                label={'Search for attendee'}
                inputProps={{
                  ...params.inputProps,
                  'aria-label': 'attendee id',
                }}
                InputProps={{
                  ...params.InputProps,
                }}
              />
            </>
          )
        }}
      />
    </Box>
  )
}

const Box = styled.div`
  position: relative;
  .MuiAutocomplete-popper {
    margin-top: -20px !important;
  }
`
